import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calculator } from 'lucide-react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import SEO from '@/components/seo/SEO';
import { PROGRAMMATIC_VERTICALS } from '@/lib/programmaticData';

const CalculatorsHubPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#f8f5ef] pb-24 text-slate-900">
      <SEO
        title="Financing Calculators by Industry"
        description="Estimate monthly payment options and potential sales lift by business type using LendLifted financing calculators."
        canonical="/calculators"
      />

      <section className="px-6 pb-16 pt-28 md:pt-32">
        <div className="container mx-auto max-w-5xl">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Calculator Hub</p>
          <h1 className="mt-3 font-sans text-4xl text-slate-900 md:text-6xl">Payment-plan calculators for high-ticket sellers</h1>
          <p className="mt-4 max-w-3xl text-lg text-slate-600">
            Pick your industry and model buyer-friendly monthly options, plus estimated revenue lift when financing is offered at checkout.
          </p>
        </div>
      </section>

      <section className="px-6">
        <div className="container mx-auto grid max-w-6xl gap-4 md:grid-cols-2">
          {PROGRAMMATIC_VERTICALS.map((vertical, idx) => (
            <motion.div
              key={vertical.slug}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ delay: idx * 0.04, duration: 0.35 }}
            >
              <Card className="h-full rounded-3xl border border-slate-200 bg-white shadow-sm">
                <CardContent className="p-6">
                  <div className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
                    <Calculator className="mr-2 h-3.5 w-3.5" />
                    {vertical.industry}
                  </div>
                  <h2 className="mt-3 font-sans text-2xl text-slate-900">{vertical.title}</h2>
                  <p className="mt-2 text-sm text-slate-600">{vertical.summary}</p>
                  <Button asChild className="mt-5 rounded-full bg-slate-900 text-white hover:bg-slate-800">
                    <Link to={`/calculators/${vertical.slug}`}>
                      Open calculator
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CalculatorsHubPage;
